export default "__VITE_ASSET__B1BhqQ7Z__"